var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData.series.length)?_c('apexchart',{attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.chartData.series,"height":"350"}}):_c('div',[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }